import api from '@/config/api';
class UserRepository {
	async filterUsers(filterParam) {
		return await api.tinn.get('/api/user/search?query=' + filterParam).then((response) => response.data.data.result);
	}
}

export default new UserRepository();
